import { render, staticRenderFns } from "./myAvatar.vue?vue&type=template&id=aebe2de8&scoped=true&"
import script from "./myAvatar.vue?vue&type=script&lang=js&"
export * from "./myAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebe2de8",
  null
  
)

export default component.exports